import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PortfolioProvider } from "./context/PortfolioContext";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import InsightsPage from "./pages/InsightsPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <HelmetProvider>
      <PortfolioProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </div>
      </PortfolioProvider>
    </HelmetProvider>
  );
}

export default App;
